<template>
    <Paper class="profile-nav-root" v-on-clickaway="emitClose">
        <div class="d-flex align-items-center p-3">
            <Avatar class="mr-2" :image="getProfileImage()">{{
                nameAbbr
            }}</Avatar>
            <div>
                <h5 class="subtitle bold mb-0">{{ getFullName() }}</h5>
                <h6 class="subtitle mb-0">{{ getEmail() }}</h6>
            </div>
        </div>
        <Divider />
        <template v-for="a in actions">
            <div
                class="d-flex align-items-center px-3 py-2 clickable noselect"
                :key="a.label"
                @click="a.action"
            >
                <BaseIcon :name="a.icon" />
                <h6 class="mb-0">{{ a.label }}</h6>
            </div>
        </template>
    </Paper>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import AuthService from '~/services/AuthService';
import i18n from '~/i18n';

export default {
    mixins: [clickaway],
    name: 'ProfileNavigation',
    props: {
        nameAbbr: String, // The first letter of the firstName
    },
    data() {
        return {
            actions: [
                {
                    action: function() {
                        AuthService.logOut();
                        if (this.$route.meta && this.$route.meta.requiresAuth) {
                            this.$router.push(this.$URLS.findjobs);
                        }
                    }.bind(this),
                    label: i18n.t(
                        'components.navigation.profileNavigation.signOut'
                    ),
                    icon: 'sign-out-alt',
                },
            ],
        };
    },
    computed: {
        user() {
            return this.$interfaces.user.me.get({ reactive: true });
        },
    },
    methods: {
        userData() {
            return this.user.data;
        },
        emitClose() {
            this.$emit('close');
        },
        getFullName() {
            const user = this.userData() || {};
            return (user.firstName || '') + ' ' + (user.lastName || '');
        },
        getEmail() {
            const user = this.userData() || {};
            return user.email;
        },
        getProfileImage() {
            const user = this.userData() || {};
            return user.image;
        },
    },
};
</script>

<style scoped>
.profile-nav-root {
    position: absolute;
    top: 64px;
    right: 10px;
    min-width: 240px;
    max-width: 100vw;
    height: auto;
    color: white;

    box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.4);
}
</style>
